import { render, staticRenderFns } from "./ReviewYourAnswersNPR.vue?vue&type=template&id=efca7478"
import script from "./ReviewYourAnswersNPR.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersNPR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports